module.exports = __webpack_public_path__ + "static/media/profile-placeholder.e2f4f909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile-placeholder.png
// module id = ./src/assets/profile-placeholder.png
// module chunks = 0